import { z } from "zod";
import type {
    StorageItemImageId} from "./storage-item-images/storage-item-image-id";
import {
    isStorageItemImageId,
    storageItemImageIdZodSchema,
} from "./storage-item-images/storage-item-image-id";
import type {
    StorageItemPdfId} from "./storage-item-pdfs/storage-item-pdf-id";
import {
    isStorageItemPdfId,
    storageItemPdfIdZodSchema,
} from "./storage-item-pdfs/storage-item-pdf-id";
import type {
    StorageItemSvgId} from "./storage-item-svgs/storage-item-svg-id";
import {
    isStorageItemSvgId,
    storageItemSvgIdZodSchema,
} from "./storage-item-svgs/storage-item-svg-id";

type StorageItemId = StorageItemPdfId | StorageItemImageId | StorageItemSvgId;

// Svg
const storageItemIdZodSchema = z.union([
    storageItemImageIdZodSchema,
    storageItemPdfIdZodSchema,
    storageItemSvgIdZodSchema,
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isStorageItemId = (id: any): id is StorageItemId => {
    return (
        isStorageItemImageId(id) ||
        isStorageItemPdfId(id) ||
        isStorageItemSvgId(id)
    );
};

// Generic
export { isStorageItemId, storageItemIdZodSchema };
export type { StorageItemId };
